<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2025-09-26 09:02:54
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2025-12-10 10:46:30
 * @FilePath: \vue-app-console\src\views\BikeModel\BikeModelList.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div>
        <Header :headerData="headerData"></Header>
        <!-- 新增车型 -->
        <a-modal 
            v-model:visible="addVisible" 
            :title="$t('bikeModel.addBikeModel')" 
            :cancelText="$t('base.cancel')"
            :okText="$t('base.confirm')"
            :width="600"
            centered
            :bodyStyle="{ paddingTop: '8px' }"
            :maskClosable="false"
            :okButtonProps="{ disabled: okBtnDisabled }"
            @ok="handle('confirmAdd')"
            @cancel="handle('cancelAdd')"
            @afterClose="handle('cancelAdd')"
        >
            <div style="margin-top: 2px;">
                <Form 
                    :form="addForm"
                    @uploadChange="uploadChange"
                    @uploadRemove="uploadRemove"
                >
                    <template #formSlot>
                        <div style="color:#808080;margin-top:-20px;text-align:center;">
                            {{$t('bikeModel.imageUploadTip')}}
                        </div>
                    </template>
                </Form>
            </div>
        </a-modal>

        <a-input 
            v-model:value="vehicle_model" 
            allowClear 
            :placeholder="t('bikeModel.vehicleModel')" 
            style="width: 200px; margin: 40px 10px 10px 0" 
            @change="handleInputChange()"
        />

        <div class="operate_btn">
            <a-button type="primary" size="small" style="margin-right:10px;margin-bottom:10px" @click="handle('add')">
                <component :is="$antIcons['PlusOutlined']"></component>
                {{ $t('base.add') }}
            </a-button>
        </div>

        <!-- 表格 -->
        <Table
            ref="tableRef"
            :table="table"
            @handleChangePagination="handleChangePagination"
            
        >
            <template v-slot:customCol="{props}">
                <template v-if="props.column.key === 'status'">
                    <span>{{ props.record.status }}</span>
                </template>
                <template v-if="props.column.key === 'picture_url'">
                    <span v-if="!props.record.picture_url || props.record.picture_url === '-'">-</span>
                    <a-image v-else :width="60" :src="props.record.picture_url"></a-image>
                </template>
            </template>

            <template v-slot:tableAction="{props}">
                <template v-if="props.column.key === 'action'">
                    <a-button size="small" :disabled="props.record.status_val == 1" @click="handle('cancel',props.record)">{{ $t('base.cancel') }}</a-button>
                </template>
            </template>
        </Table>
    </div>
    
</template>

<script setup>
    import { onMounted, ref, reactive } from "vue";
    import Table from "@/components/Table.vue";
    import Header from "@/layouts/component/Header.vue";
    import Form from "@/components/Form.vue";
    import { useI18n } from 'vue-i18n';
    import { message, Modal } from 'ant-design-vue';
    import { BikeModelApi } from '@/api/BikeModelApi.js';
    import { FaultApi } from '@/api/FaultApi.js';
    import { getWeek } from '@/hooks/useGetWeek';
    import { formatTimestamp, debounce } from '@/utils/global';

    const { t } = useI18n()

    const addVisible = ref(false)
    const okBtnDisabled = ref(false)
    const vehicle_model = ref('')

    const headerData = ref({
        menu:'menu.BikeModel',
        menu_desc: 'menu.subFirmware',
        week: getWeek().week,
        current_time: getWeek().currentDate,
    })

    const table = ref({
        data: [],
        columns: [
            {
                title: t('bikeModel.vehicleModel'),
                dataIndex: 'vehicle_model',
                key: 'vehicle_model',
                width: 180,
                resizable: true,
                ellipsis: true,
                fixed: 'left',
            },
            {
                title: t('bikeModel.vehicleModelAbbr'),
                dataIndex: 'vehicle_model_abbr',
                key: 'vehicle_model_abbr',
                width: 160,
                resizable: true,
                ellipsis: true,
            },
            {
                title: t('bikeModel.pictureUrl'),
                dataIndex: 'picture_url',
                key: 'picture_url',
                width: 220,
                resizable: true,
                ellipsis: true,
            },
            {
                title: t('bikeModel.status'),
                dataIndex: 'status',
                key: 'status',
                width: 120,
                resizable: true,
                ellipsis: true,
                filterMultiple: false,
                filters: [
                    { text: t('base.normal'), value: t('base.normal') },
                    { text: t('base.canceled'), value: t('base.canceled') },
                ],
                onFilter: (value, record) => record.status.indexOf(value) === 0,
            },
            {
                title: t('bikeModel.createTime'),
                dataIndex: 'create_timestamp',
                key: 'create_timestamp',
                width: 160,
                resizable: true,
                ellipsis: true,
            },
            {
                title: t('bikeModel.cancelTime'),
                dataIndex: 'cancel_timestamp',
                key: 'cancel_timestamp',
                width: 160,
                resizable: true,
                ellipsis: true,
            },
            {
                title: t('base.operate'),
                key: 'action',
                fixed: 'right',
                width: 160,
                resizable: true,
            },
        ],
        configs: {
            table: {
                rowClassName:(record, index) => (index % 2 === 1 ? 'table-striped' : null)
            },
            scroll: {
                x: 1500,
                y: 580,
            },
            rowSelection: false,
            loading: false,
            pagination:{
                hideOnSinglePage:false,
                position:['bottomLeft'],
                responsive:true,
                current:1,
                pageSize:10,
                showSizeChanger: true,
                pageSizeOptions:['10','20','50'],
                total:0,
                // showTotal:()=>t('base.total') + ` ${table.value.configs.pagination.total} ` + t('base.row')
            },
            operateBtn: {
                showSearch: false,
                showAdd: false,
            }
        },
    })

    const addForm = reactive({
        layout:'horizontal',
        labelCol:{ span: 8 },
        wrapperCol:{ span: 14 },
        formData:{
            vehicle_model:'',
            vehicle_model_abbr:'',
            picture_url:'',
            status:0,
        },
        formField:[
            { type:'input', key:'vehicle_model', name_lang:'bikeModel.vehicleModel', placeholder_lang:'base.enter', required:true, maxlength:100, width:'240px', display:'block' },
            { type:'input', key:'vehicle_model_abbr', name_lang:'bikeModel.vehicleModelAbbr', placeholder_lang:'base.enter', required:true, maxlength:50, width:'240px', display:'block' },
            { 
                type:'uploadImg', 
                key:'pictureUrl_upload', 
                name_lang:'bikeModel.pictureUrl', 
                required:true,
                width:'85%',
                display:'block',
                uploadImgData:{
                    title:'',
                    imgList:[],
                    accept:'.jpg,.jpeg,.png,.webp,.bmp,.tif,.gif',
                    action:'',
                    headers:{}
                }
            },
        ]
    })
    


    // 设置上传控件的标题
    const setUploadTitle = ()=>{
        addForm.formField.forEach(item=>{
            if(item.type === 'uploadImg'){
                item.uploadImgData.title = t('base.uploadImg')
            }
        })
    }

    const handle = (type, row)=>{
        switch(type){
            case 'add':
                resetAddForm()
                setUploadTitle()
                okBtnDisabled.value = false
                addVisible.value = true
                break;
            case 'confirmAdd':
                confirmAdd()
                break;
            case 'cancelAdd':
                handleCancelAdd()
                break;
            case 'cancel':
                Modal.confirm({
                    title: t('base.tip'),
                    content: t('bikeModel.cancelConfirm'),
                    okText: t('base.confirm'),
                    onOk(){
                        cancelModel(row)
                    },
                })
                break;
        }
    }

    // 重置新增表单
    const resetAddForm = ()=>{
        addForm.formData.vehicle_model = ''
        addForm.formData.vehicle_model_abbr = ''
        addForm.formData.picture_url = ''
        addForm.formData.status = 0
        // 清空上传列表
        addForm.formField.forEach(item=>{
            if(item.type === 'uploadImg'){
                item.uploadImgData.imgList = []
            }
        })
    }

    // 取消新增
    const handleCancelAdd = ()=>{
        addVisible.value = false
        resetAddForm()
        okBtnDisabled.value = false
    }

    const handleChangePagination =  (config)=> {
        table.value.configs.pagination.current = config.current
        table.value.configs.pagination.pageSize = config.pageSize
        table.value.configs.loading = true
        getList()
    }

    const handleInputChange = debounce(()=>{
        table.value.configs.pagination.current = 1
        getList()
    }, 500)

    // 获取车型列表
    const getList = async ()=>{
        table.value.configs.loading = true
        let page = table.value.configs.pagination.current
        let size = table.value.configs.pagination.pageSize
        let res = await BikeModelApi.getInstance().getBikeModelList({ vehicle_model: vehicle_model.value.trim() }, page, size)
        if(res.code === 200 || res.code === 0){
            const data = res.data
            data.records.forEach((i,index)=>{
                i.status_val = i.status
                i.status = i.status_val == 0? t('base.normal') : t('base.canceled')
                i.create_timestamp = formatTimestamp(i.create_timestamp)
                i.cancel_timestamp = formatTimestamp(i.cancel_timestamp)
                i.vehicle_model = i.vehicle_model || '-'
                i.vehicle_model_abbr = i.vehicle_model_abbr || '-'
                i.picture_url = i.picture_url || '-'
            })
            table.value.data = data.records
            table.value.configs.pagination.total = data.total
            table.value.configs.pagination.current = data.current || page
        }else{
            message.error(res.message || res.msg || t('base.getDataFail'))
        }
        table.value.configs.loading = false
    }

    // 新增车型
    const confirmAdd = async ()=>{
        if(okBtnDisabled.value){ return message.warning(t('base.needUploadImg') || 'Please upload pictures!') }
        if(!addForm.formData.vehicle_model){ return message.error(`${t('bikeModel.vehicleModel')} ${t('base.noEmpty')}`) }
        if(!addForm.formData.vehicle_model_abbr){ return message.error(`${t('bikeModel.vehicleModelAbbr')} ${t('base.noEmpty')}`) }
        if(!addForm.formData.picture_url){ return message.error(`${t('bikeModel.pictureUrl')} ${t('base.noEmpty')}`) }
        // table.value.configs.loading = true
        let res = await BikeModelApi.getInstance().addBikeModel({
            vehicle_model:addForm.formData.vehicle_model.trim(),
            vehicle_model_abbr:addForm.formData.vehicle_model_abbr.trim(),
            picture_url:addForm.formData.picture_url.trim(),
            status:0,
        })
        if(res.code === 0){
            message.success(t('base.addSuccessMsg'))
            addVisible.value = false
            table.value.configs.pagination.current = 1
            getList()
        }else{
            message.error(res.message || res.msg)
            table.value.configs.loading = false
        }
    }

    // 上传图片，获取云端URL并回填
    const uploadChange = async (file, fileList)=>{
        // 文件大小限制：不超过 10MB（兼容性检查 file 与 fileList[0]）
        const currentFileObj = (file && file.originFileObj) ? file.originFileObj : (fileList && fileList[0] && fileList[0].originFileObj ? fileList[0].originFileObj : null)
        if (currentFileObj && (currentFileObj.size / 1024 / 1024 > 10)) {
            message.warning(t('base.imgTooLarge'))
            // 清空上传列表并重置表单字段  
            addForm.formField.forEach(item=>{
                if(item.type === 'uploadImg'){
                    item.uploadImgData.imgList = []
                }
            })
            addForm.formData.picture_url = ''
            okBtnDisabled.value = false
            return
        }
        if(fileList.length > 0){
            okBtnDisabled.value = true
            const hide = message.loading({ content: t('base.pictureUploading'), duration: 0 })
            let form = new FormData()
            form.append('file', fileList[0].originFileObj)
            let res = await FaultApi.getInstance().uploadPictures(form)
            if(res.code === 0){
                addForm.formData.picture_url = res.data.download_path
                // 同步预览列表为已上传URL
                addForm.formField.forEach(item=>{
                    if(item.type === 'uploadImg'){
                        item.uploadImgData.imgList = [{ url: res.data.download_path }]
                    }
                })
                hide()
                message.success(t('base.uploadSuccess'))
            }else{
                hide()
                message.error(res.msg || t('base.getDataFail'))
            }
            okBtnDisabled.value = false
        }
    }

    // 删除已选图片
    const uploadRemove = ()=>{
        addForm.formData.picture_url = ''
    }

    // 禁用车型
    const cancelModel = async (row)=>{
        table.value.configs.loading = true
        let res = await BikeModelApi.getInstance().cancelBikeModel(row.id)
        if(res.code === 0){
            message.success(t('bikeModel.cancelMsg'))
            await getList()
        }else{
            message.error(res.message || res.msg)
            table.value.configs.loading = false
        }
    }

    onMounted(()=>{
        getList()
    })
</script>

<style lang="scss" scoped>
::v-deep .ant-table-wrapper .ant-table-thead>tr>th, 
::v-deep .ant-table-wrapper .ant-table-tbody>tr>td, 
::v-deep .ant-table-wrapper tfoot>tr>td{
    padding: 6px 16px;
}

::v-deep .page_header .week{
    margin-top: -55px;
    transform: translateY(8px);
}
::v-deep .page_header .admin_email{
    margin-top: -55px;
    transform: translateY(18px);
}

// 当sub不为空时
// ::v-deep .page_header .week{
//     margin-top: -70px;
// }
// ::v-deep .page_header .admin_email{
//     margin-top: -60px;
// }

// 上传图片使用表单 label 对齐
::v-deep .uploadImg{
    margin-left: 0;
}

</style>